import { CurrencyPipe, I18nPluralPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CoreModule } from 'app/core/core.module';
import * as moment from 'moment';

@Component({
  standalone: true,
  selector: 'app-fundraiser-donation',
  templateUrl: './fundraiser-donation.component.html',
  styleUrl: './fundraiser-donation.component.scss',
  providers: [I18nPluralPipe],
  imports:[CurrencyPipe,CoreModule]
})
export class FundraiserDonationComponent implements OnInit{

  @Input() donation = null;
  @Input() index = null;

  public updated = null;

  constructor() {}
  
  ngOnInit() {
    // handle when updated is a timestamp or a date
    const now = moment().unix();
    const updatedTimestamp = typeof this.donation.updated === 'number' 
      ? this.donation.updated
      : moment(this.donation.updated).unix();
    
    this.updated = now - updatedTimestamp;
  }
}
